import {
    GET_ALL_TEMPLATES,
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    GET_FETCH_DATA,
    GET_GROUPS_DATA,
    GET_GROUP_USERS,
} from './campaignTypes'

export default (state, action) => {
    switch (action.type) {
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case GET_ALL_TEMPLATES:
            return {
                ...state,
                all_templates: action.payload,
            }
        case GET_FETCH_DATA:
            return {
                ...state,
                all_campaigns: action.payload,
            }
        case GET_GROUPS_DATA:
            return {
                ...state,
                all_groups: action.payload,
            }
        case GET_GROUP_USERS:
            return {
                ...state,
                all_group_users: action.payload,
            }

        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        default:
            return state
    }
}
